<app-opa-header />
<div class="host-this-tool-wrapper">
  <h1>Host this Tool</h1>
  <p>
    OPA has developed a Family Planning Clinic Locator widget to allow other
    websites to host this tool.
  </p>

  <h2>Instructions</h2>
  <ol>
    <li>
      Locate the section of your website where you wish to embed the Family
      Planning Clinic Locator widget.
    </li>
    <li>
      Copy the following HTML code snippet:
      <div class="code-snippet">
        <pre>
          <code [highlight]="widgetCode" language="html" lineNumbers></code>
        </pre>
        <button
          [cdkCopyToClipboard]="widgetCode"
          mat-icon-button
          matToolTip="Copy to clipboard"
          aria-label="Copy to clipboard"
          (click)="openSnackBar('Code copied')"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </li>
    <li>
      Adjust the width and height values to fit the widget appropriately within
      your website's layout. These values can be specified in pixels (e.g.,
      width="600" for 600 pixels wide) or percentages (e.g., width="100%" to
      fill the width of the containing element).
    </li>
    <li>
      Paste the modified HTML code snippet into the HTML file of your website,
      in the location where you want the widget to appear.
    </li>

    <li>Save the changes to your website's HTML file.</li>
    <li>
      Preview your website to ensure the widget is displayed correctly and is
      functional.
    </li>
    <li>
      If necessary, adjust the width and height values to better integrate the
      widget into your site's design.
    </li>
  </ol>
  <h2>Examples</h2>
  <div class="widget-previews">
    <div class="width-set-widgets">
      <iframe
        aria-label="Family Planning Clinic Locator widget 1"
        scrolling="no"
        frameborder="0"
        width="200"
        height="260"
        src="https://reproductivehealthservices.gov/locator-widget/partner-sidebar-1"
      ></iframe>
      <iframe
        aria-label="Family Planning Clinic Locator widget 2"
        scrolling="no"
        frameborder="0"
        width="294"
        height="150"
        src="https://reproductivehealthservices.gov/locator-widget/partner-sidebar-1"
      ></iframe>
    </div>
    <iframe
      aria-label="Family Planning Clinic Locator widget 3"
      scrolling="no"
      frameborder="0"
      width="100%"
      height="150"
      src="https://reproductivehealthservices.gov/locator-widget/partner-sidebar-1"
    ></iframe>
  </div>
</div>
